// WebSocket API
const apiWebSocket = new WebSocket(
  "wss://2ktdqfk7w4.execute-api.ap-northeast-2.amazonaws.com/production/"
);

export default apiWebSocket;
